export default "__VITE_ASSET__BbPUGo9f__"